import { getMappedLanguage } from 'i18n/helpers';
import {
  CHAT_SETTINGS_BY_BRAND_ID_ENDPOINT,
  CHAT_SETTINGS_ENDPOINT,
  CHAT_SETTINGS_VERSION_BY_BRAND_ID_ENDPOINT,
  CHAT_SETTINGS_VERSION_ENDPOINT,
} from './constants';
import { FetchSettingsParameters } from './types';

export const makeGetChatSettingsVersionEndpoint = (parameters: {
  brandId?: string;
}) => {
  const brandId = parameters?.brandId;

  let endpoint = CHAT_SETTINGS_VERSION_ENDPOINT;

  if (brandId) {
    endpoint = `/p/v1/chat/brands/${brandId}/settings/versions/latest`;
  }

  return endpoint as
    | typeof CHAT_SETTINGS_VERSION_ENDPOINT
    | typeof CHAT_SETTINGS_VERSION_BY_BRAND_ID_ENDPOINT;
};

export const makeGetChatSettingsEndpoint = (
  parameters: FetchSettingsParameters,
) => {
  const brandId = parameters?.brandId;
  const lang = parameters?.lang;
  const settingsVersion = parameters?.settingsVersion;

  let endpoint = CHAT_SETTINGS_ENDPOINT;

  if (brandId) {
    endpoint = `/p/v2/chat/brands/${brandId}/settings`;
  }

  const mappedLang = getMappedLanguage(lang);

  const queryParams = new URLSearchParams();

  if (lang) {
    queryParams.set('lang', mappedLang);
  }

  if (settingsVersion !== undefined) {
    queryParams.set('settingsVersion', settingsVersion.toString());
  }

  const queryString = queryParams.toString();

  if (queryString.length) {
    endpoint = `${endpoint}?${queryString}`;
  }

  return endpoint as
    | typeof CHAT_SETTINGS_ENDPOINT
    | typeof CHAT_SETTINGS_BY_BRAND_ID_ENDPOINT;
};
